// src/components/Footer.jsx
import { TriangleAlert } from "lucide-react";

// 1. Accept 'user' as a prop
const Footer = ({ user }) => {
  return (
    <footer className="fixed bottom-0 left-0 z-40 w-full bg-gray-900 text-gray-400 p-3 flex justify-between items-center text-xs">
      
      {/* Left-aligned Version - Wrapper kept for layout, content hidden if logged out */}
      <div className="flex-1 text-left">
        {user && <span>Version 6.3</span>}
      </div>

      {/* Centered Copyright - Always visible */}
      <div className="flex-1 text-center">
        <span>Copyright &copy; 2026 Trapound</span>
      </div>

      {/* Right-aligned Disclaimer - Wrapper kept for layout, content hidden if logged out */}
      <div className="flex-1 text-right">
        {user && (
          <div className="relative group inline-flex items-center gap-2 cursor-pointer text-yellow-500">
            <span className="font-semibold">Risk Disclaimer</span>
            <TriangleAlert className="h-4 w-4 text-yellow-500" />

            {/* The Tooltip */}
            <div
              className="absolute bottom-full right-0 mb-2 w-96 p-4 bg-gray-800 text-gray-200 
                       rounded-lg shadow-lg text-left font-sm text-sm leading-relaxed
                       opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
            >
              <div className="space-y-3">
                <p>
                  Trading futures, foreign exchange (forex), stocks and options involves a high degree of risk and is not suitable for all investors. Only trade with money you can afford to lose completely. Please be aware that you could lose more than your initial investment. Past performance is not an indicator of future results.
                </p>
                <p>
                  <strong className="text-white">No financial advice.</strong> Trapound provides journaling, analytics, and educational tools only. We do not provide investment, trading, legal, tax, or other professional advice.
                </p>
                <p>
                  <strong className="text-white">No signals, ideas, or setups.</strong> Trapound does not provide trade signals, trade recommendations, or specific trade setups. Any examples or educational content are illustrative only.
                </p>
                <p>
                  <strong className="text-white">Not a broker or advisor.</strong> Trapound is not a broker-dealer, investment adviser, commodity trading advisor (CTA), or money manager; we do not execute trades.
                </p>
               <p>
                <strong className="text-white">No guarantee of results.</strong> We do not guarantee improved performance, reduced risk, or profit.
              </p>
              </div>
              {/* Tooltip Arrow */}
              <div className="absolute bottom-0 right-3 w-3 h-3 bg-gray-800 transform rotate-45 -mb-1"></div>
            </div>
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;